import React from 'react';
import { FaRegNewspaper } from 'react-icons/fa';
import { HiOutlineDocumentText } from 'react-icons/hi';

const NewsPageComponent = () => {
  const articles = [
    {
      title: 'IPSA Launches New Patient Safety Initiative',
      date: 'October 5, 2025',
      summary: 'The Institute for Patient Safety Africa has launched a continent-wide initiative to improve hospital safety protocols.',
      link: '/news/ipsa-launch-initiative',
      img_url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQ8e-FkHyRBleHA_R_mFMZciYcsrdwbRAwqA&s',
    },
    {
      title: 'Kenya Health Summit 2025 Highlights Innovation',
      date: 'September 28, 2025',
      summary: 'Healthcare leaders gathered in Nairobi to discuss digital transformation and patient-centered care.',
      link: '/news/kenya-health-summit',
      img_url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLyoVJWqdV0M4e-KNsdFMXO5zY_zOAgZJJwA&s"
    },
    {
      title: 'New Accreditation Standards Released',
      date: 'September 20, 2025',
      summary: 'IPSA released updated accreditation guidelines for hospitals and clinics across East Africa.',
      link: '/news/accreditation-standards',
      img_url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7t9bEY_zIvI9TgSe7eOS4zRXX4Om_PogqeQ&s"
    },
    {
      title: 'IPSA Partners with African Hospital Consortium',
      date: 'September 15, 2025',
      summary: 'A strategic partnership aims to expand training and quality audits across member hospitals.',
      link: '/news/ipsa-ahc-partnership',
      img_url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSuuzCdt0s4s10x_ki7j8tA8yYOtZlVYBgA_Q&s"
    },
    {
      title: 'Digital Health Strategy Workshop Recap',
      date: 'September 10, 2025',
      summary: 'Experts shared insights on implementing digital health tools in resource-limited settings.',
      link: '/news/digital-health-workshop',
      img_url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRB5nN5KjJvsPTQblTZ1V3byMsgcmFc_0Eunw&s"
    },
    {
      title: 'Patient Safety Week Celebrated Nationwide',
      date: 'September 1, 2025',
      summary: 'Hospitals across Kenya hosted events to raise awareness about patient safety practices.',
      link: '/news/patient-safety-week',
      img_url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRB5nN5KjJvsPTQblTZ1V3byMsgcmFc_0Eunw&s"
    },  
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-6 lg:px-20">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl flex justify-left items-center font-bold text-blue-900 mb-6 text-left">
            <FaRegNewspaper size={28} className="text-blue-600 mr-4" />
             News
        </h2>
        <hr className='mb-6'/>
        <div className=' flex justify-right items-center mb-3'>
          <button  className='text-blue-900 flex justify-right items-center  font-bold mb-3'>
            <HiOutlineDocumentText size={20} className='mr-2' />
            Publish an article on IPSA?
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {articles.map((article, index) => (
            <a
              key={index}
              href={article.link}
              className="bg-blue-800 shadow-md rounded-lg p-6 hover:shadow-lg transition"
            >
              <h3 className="text-xl font-semibold text-blue-200 mb-2">{article.title}</h3>
              <p className="text-sm text-gray-200 mb-2">{article.date}</p>
              <div className='w-full'>
                <hr className="border-gray-500 mt-2 mb-4" />
                <img src={article.img_url} alt="news_image" className="mb-4 w-full rounded-xl" />
              </div>
              <p className="text-gray-100 mb-4">{article.summary}</p>
              <span className="text-green-400 hover:underline text-sm">Read more →</span>
            </a>
          ))}
        </div>
        <div className='flex justify-center mt-4'>
            <button className="mt-8 px-4 py-2 bg-blue-300 m-1 text-white font-semibold rounded-md hover:bg-blue-700 transition">
              Previous
            </button>
            <button className="mt-8 px-4 py-2 bg-blue-500 m-1 text-white font-semibold rounded-md hover:bg-blue-700 transition">
              1
            </button>
             <button className="mt-8 px-4 py-2 bg-blue-500 m-1 text-white font-semibold rounded-md hover:bg-blue-700 transition">
              2
            </button>
             <button className="mt-8 px-4 py-2 bg-blue-500 m-1 text-white font-semibold rounded-md hover:bg-blue-700 transition">
              3
            </button>
             <button className="mt-8 px-4 py-2 bg-blue-500 m-1 text-white font-semibold rounded-md hover:bg-blue-700 transition">
              Next
            </button>
        </div>
      </div>
    </div>
  );
};

export default NewsPageComponent;
